import { IoExtensionPuzzleOutline, IoStorefrontOutline } from 'react-icons/io5'
import {
  MdOutlineDashboard,
  MdOutlineMonitorHeart,
  MdOutlinePointOfSale,
  MdOutlineRocketLaunch,
} from 'react-icons/md'

import { classNames } from '@/utils'

export const links = [
  {
    id: 1,
    name: 'Dashboard',
    route: '/',
    icon: (isActive: boolean) => (
      <MdOutlineDashboard
        className={classNames('text-2xl text-gray', { 'text-saturine': isActive })}
      />
    ),
  },
  {
    id: 2,
    name: 'Groups',
    route: '/groups',
    icon: (isActive: boolean) => (
      <IoExtensionPuzzleOutline
        className={classNames('text-2xl text-gray', { 'text-saturine': isActive })}
      />
    ),
  },
  {
    id: 3,
    name: 'Stores',
    route: '/stores',
    icon: (isActive: boolean) => (
      <IoStorefrontOutline
        className={classNames('text-2xl text-gray', { 'text-saturine': isActive })}
      />
    ),
  },
  {
    id: 4,
    name: 'Sell Treez',
    route: '/sell-treez',
    icon: (isActive: boolean) => (
      <MdOutlinePointOfSale
        className={classNames('text-2xl text-gray', { 'text-saturine': isActive })}
      />
    ),
  },
  {
    id: 5,
    name: 'Store Operations',
    route: '/operations/groups',
    icon: (isActive: boolean) => (
      <MdOutlineMonitorHeart
        className={classNames('text-2xl text-gray', { 'text-saturine': isActive })}
      />
    ),
  },
  {
    id: 6,
    name: 'Front Deployment',
    route: '/frontend-deployment',
    icon: (isActive: boolean) => (
      <MdOutlineRocketLaunch
        className={classNames('text-2xl text-gray', { 'text-saturine': isActive })}
      />
    ),
  },
]
